import { Errors } from '../objects/errors';

export const SET_ERRORS = 'LOGIN_SET_ERRORS';
export const SET_MFA_ATTEMPTS_REMAINING = 'LOGIN_SET_MFA_ATTEMPTS_REMAINING';
export const SET_MFA_CODE_ERROR = 'LOGIN_SET_MFA_CODE_ERROR';
export const SET_MFA_PENDING = 'LOGIN_SET_MFA_PENDING';
export const TOGGLE_FORGOT_PASSWORD = 'LOGIN_TOGGLE_FORGOT_PASSWORD';
export const TOGGLE_FORGOT_PASSWORD_EMAIL_SENT = 'LOGIN_TOGGLE_FORGOT_PASSWORD_EMAIL_SENT';
export const TOGGLE_PASSWORD = 'LOGIN_TOGGLE_PASSWORD';
export const UPDATE_EMAIL = 'LOGIN_UPDATE_EMAIL';
export const UPDATE_MFA_CODE = 'LOGIN_UPDATE_MFA_CODE';
export const UPDATE_PASSWORD = 'LOGIN_UPDATE_PASSWORD';

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Errors
}

interface SetMfaAttemptsRemainingAction {
    type: typeof SET_MFA_ATTEMPTS_REMAINING,
    payload: number
}

interface SetMfaCodeErrorAction {
    type: typeof SET_MFA_CODE_ERROR,
    payload: string
}

interface SetMfaPendingAction {
    type: typeof SET_MFA_PENDING,
    payload: boolean
}

interface ToggleForgotPasswordAction {
    type: typeof TOGGLE_FORGOT_PASSWORD
}

interface ToggleForgotPasswordEmailSentAction {
    type: typeof TOGGLE_FORGOT_PASSWORD_EMAIL_SENT
}

interface ToggleShowPasswordAction {
    type: typeof TOGGLE_PASSWORD
}

interface UpdateEmailAction {
    type: typeof UPDATE_EMAIL,
    payload: string
}

interface UpdateMfaCodeAction {
    type: typeof UPDATE_MFA_CODE,
    payload: string
}

interface UpdatePasswordAction {
    type: typeof UPDATE_PASSWORD,
    payload: string
}

export type LoginActionTypes =
    SetErrorsAction |
    SetMfaAttemptsRemainingAction |
    SetMfaCodeErrorAction |
    SetMfaPendingAction |
    ToggleForgotPasswordAction |
    ToggleForgotPasswordEmailSentAction |
    ToggleShowPasswordAction |
    UpdateEmailAction |
    UpdateMfaCodeAction |
    UpdatePasswordAction;